var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "53px",
    viewBox: "0 0 40 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file-video-regular") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-video-regular",
    transform: "translate(-654.000000, -798.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(654.000000, 798.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5355208,10.1384238 L29.7978125,1.45532617 C28.860136,0.523503211 27.5883715,0 26.2622917,0 L5,0 C2.23854167,0 0,2.22455078 0,4.96875 L0,48.03125 C0,50.7754492 2.23854167,53 5,53 L35,53 C37.7614583,53 40,50.7754492 40,48.03125 L40,13.6518477 C40,12.3340559 39.4732043,11.0702399 38.5355208,10.1384238 L38.5355208,10.1384238 Z M34.595625,13.25 L26.6666667,13.25 L26.6666667,5.37059766 L34.595625,13.25 Z M5,48.03125 L5,4.96875 L21.6666667,4.96875 L21.6666667,15.734375 C21.6666667,17.1064746 22.7859375,18.21875 24.1666667,18.21875 L35,18.21875 L35,48.03125 L5,48.03125 Z M28.8215625,26.1580879 L23.3333333,31.6109805 L23.3333333,27.7421875 C23.3333333,26.5987539 22.400625,25.6718493 21.25,25.6718493 L10.4166667,25.6718493 C9.26604167,25.6718493 8.33333333,26.5987539 8.33333333,27.7421875 L8.33333333,38.5078125 C8.33333333,39.6512461 9.26604167,40.578125 10.4166667,40.578125 L21.25,40.578125 C22.400625,40.578125 23.3333333,39.6512461 23.3333333,38.5078125 L23.3333333,34.6390195 L28.8215625,40.0916016 C29.865,41.1286211 31.6666667,40.4000781 31.6666667,38.9204258 L31.6666667,27.3292637 C31.6666667,25.8478516 29.8636458,25.1224141 28.8215625,26.1580879 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.a4656c8b.svg";
export { ForwardRef as ReactComponent };